module.exports = __webpack_public_path__ + "static/media/md-alert.0b9ca738.svg";